import { API_DATA_OK } from "constant/apiData";

export function setApiDataOK(isApiDataOk: boolean) {
  return { type: API_DATA_OK, payload: isApiDataOk };
}
